import { blazeDevicePromiseClient } from '~/services/blaze-device-client';

const DEVICES_PAGE_SIZE = BigInt(1000);

export const listDevices = async () =>
  await blazeDevicePromiseClient.listDevices({
    pageSize: DEVICES_PAGE_SIZE,
  });
